export default [
  {
    name: 'Horse',
    icon: '🐎',
    url: 'https://soundbible.com/mp3/horse_blow-stephan_schutze-1678740304.mp3'
  },
  {
    name: 'Van Door',
    icon: '🚪',
    url: 'http://soundbible.com/mp3/van-sliding-door-daniel_simon.mp3'
  },
  {
    name: 'Poker Chips',
    icon: '🎰',
    url: 'http://soundbible.com/mp3/poker-chips-daniel_simon.mp3'
  },
  {
    name: 'Light Chain',
    icon: '💡⛓️',
    url: 'http://soundbible.com/mp3/light-switch-pull-chain-daniel_simon.mp3'
  },
  {
    name: 'Alert',
    icon: '🚨',
    url: 'http://soundbible.com/mp3/sms-alert-5-daniel_simon.mp3'
  },
  {
    name: 'Puppy',
    icon: '🐕',
    url: 'http://soundbible.com/mp3/puppy-barking_ds.mp3'
  },
  {
    name: 'Dragon',
    icon: '🐉',
    url: 'http://soundbible.com/mp3/European_Dragon_Roaring_and_breathe_fire-daniel-simon.mp3'
  },
  {
    name: 'Shoot Arrow',
    icon: '🏹',
    url: 'http://soundbible.com/mp3/fire_bow_sound-mike-koenig.mp3'
  },
  {
    name: 'Splash',
    icon: '💦',
    url: 'http://soundbible.com/mp3/Video_Game_Splash-Ploor-699235037.mp3'
  }
]
